export const partsTestData = [
  '9X-8600',
  '8T-9079',
  '7D-1195',
  '6V-6535',
  '6T-5068',
  '6T-0988',
  '5P-8362',
  '5P-8361',
  '5P-3620',
  '4T-3131',
  '4F-4042',
  '3G-6395',
  '326-1644',
  '326-1642',
  '253-0064',
  '253-0063',
  '253-0062',
  '229-7098',
  '1R-0762',
  '1R-0749',
  '1R-0735',
  '1G-8878',
  '140-6823',
  '139-9230',
  '138-0673',
  '138-0672',
  '132-1049',
  '130-0229',
  '117-0036',
  '106-3969',
  '9W-3488',
  '6I-2506',
  '6I-2505',
  '5K-1770',
  '5H-6733',
  '2H-6124',
  '222-1097',
  '1R-0722',
  '100-6668',
  '6L-9965',
  '220-8678',
  '1R-0719',
  '8D-7052',
  '7N-6494',
  '5M-6214',
  '5M-6213',
  '4J-0519',
  '3D-2824',
  '2J-0157',
  '2D-2511',
  '1S-2174',
  '1P-4579',
  '101-1626',
  '101-8917',
  '101-8740',
  '102-0889',
  '102-2184',
  '473-3336',
  '473-3337',
  '9N-1324',
  '9W-9352',
  '077-3569',
  '077-3058',
  '081-3957',
  '081-4662',
  '093-1433',
  '095-1716',
  '095-1633',
  '095-1585',
  '096-7570',
  '096-8294',
  '098-5747',
  '099-2374',
  '0S-1347',
  '0T-0200',
  '0S-1618',
  '0T-0244',
  '102-9388',
  '103-8254',
  '104-3601',
  '104-6730',
  '105-3035',
  '105-9218',
  '106-1609',
  '106-3973',
  '107-3469',
  '107-3490',
  '107-7832',
  '107-7088',
  '108-8421',
  '109-9214',
  '109-9121',
  '111-0575',
  '115-4223',
  '115-6315',
  '116-7462',
  '117-0170',
  '120-0664',
  '121-3661',
  '125-1302',
  '126-1757',
  '128-2686',
  '128-3883',
  '129-3178',
  '130-4679',
  '132-7167',
  '133-4995',
  '8C-3639',
  '1A-1135',
  'AAA-AAAA',
  'BBB-BBBB',
  'CCC-CCCC',
  'DDD-DDDD',
  'EEE-EEEE',
  'FFF-FFFF',
  'GGG-GGGG',
  'HHH-HHHH',
  'III-IIII',
  'JJJ-JJJJ',
  'XXX-XXXX',
  'YYY-YYYY',
  'ZZZ-ZZZZ'
];

export const message =
  "We're sorry, an unknown error has occurred. Please try again. If issues persist, please contact us.";

export const statusOptions = [
  { displayValue: 'CAT_ORD_ALL', value: 'ALL' },
  { displayValue: 'CAT_ORD_COMPLETED', value: 'F' },
  { displayValue: 'CAT_ORD_DELETED', value: 'AD' },
  { displayValue: 'CAT_PENDING_ORDERS', value: 'W' },
  { displayValue: 'CAT_ORD_REJECTED', value: 'N' }
];
